import React from "react";

import "../../assets/styles/styles.less";
import "./styles.less";
import BottomBg from "../../assets/images/2018/landing/Bottom Background.png";
import SecureImage from "../../assets/images/2018/landing/Secure Icon.png";
import MissionImage from "../../assets/images/2018/landing/Mission Icon.png";
import GuaranteeImage from "../../assets/images/2018/landing/Guarantee Icon.png";
import { hashHistory, Link } from "react-router";
import FDLogoImage from "../../assets/images/2018/landing/Logo 1.png";
import DOMLogoImage from "../../assets/images/2018/landing/Logo 2.png";

import texts from "../../assets/strings/home";

const Footer = ({ showNavigation }) => {
  const linkClick = link => {
    hashHistory.push(link);
    props.toggleMenu();
  };
  return (
    <div className="footer">
      <div className="area3-background">
        <div className="flex-column flex-center grid-100 area2">
          <div className="flex-column flex-center grid-100">
            <img className="area-image" src={GuaranteeImage} />
          </div>
          <h2 className="areaSubTitle">{texts.area3.h1}</h2>
          <div className="flex-column flex-center grid-100">
            <h3 className="areaSubText">{texts.area3.h3}</h3>
          </div>
        </div>

        <div className="flex-column flex-center grid-100 area2">
          <div className="flex-column flex-center grid-100">
            <img className="area-image" src={SecureImage} />
          </div>
          <h2 className="areaSubTitle">{texts.area4.h1}</h2>
          <div className="flex-column flex-center grid-100">
            <h3 className="areaSubText">{texts.area4.h3}</h3>
          </div>
        </div>

        <div className="flex-column flex-center grid-100 area2">
          <div className="flex-column flex-center grid-100">
            <img className="area-image" src={MissionImage} />
          </div>
          <h2 className="areaSubTitle">{texts.area5.h1}</h2>
          <div className="flex-column flex-center grid-100">
            <h3 className="areaSubText">{texts.area5.h3}</h3>
          </div>
        </div>
      </div>
      <div className="sponsors-wrapper">
        <div>
          <h2 className="areaTitle">{texts.area6.h1}</h2>
          <h3>{texts.area6.note}</h3>
        </div>
        <div className="flex-row mobile-row flex-center grid-100 area2">
          <div className="flex-column flex-center grid-50">
            <a href="http://firstdescents.org/" target="_blank">
              <img className="charity-logo" src={FDLogoImage} />
            </a>
          </div>
          <div className="flex-column flex-center grid-50">
            <a href="http://www.marchofdimes.org/" target="_blank">
              <img className="charity-logo" src={DOMLogoImage} />
            </a>
          </div>
        </div>
      </div>
      {showNavigation && (
        <div className="footer-navigation">
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/how">How it works</Link>
            </li>
            <li>
              <Link to="/proceed">Ready to proceed</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
            <li>
              <Link to="/mission">Our mission</Link>
            </li>
            <li>
              <Link to="/faq">FAQ</Link>
            </li>
            <li>
              <Link to="/legal">Legal</Link>
            </li>
          </ul>
          <p className="copyright">
            Copyright &copy; 2019 Crushpledge.com. All rights reserved.
            <div>
              <Link to="/legal">Term of use</Link>|
              <Link to="/privacy">Privacy Policy</Link>
            </div>
          </p>
        </div>
      )}
    </div>
  );
};
export default Footer;



// WEBPACK FOOTER //
// ./components/Controls/Footer.js